/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Icon, Dialog, DialogActions, DialogTitle, DialogContent, IconButton, Typography, AppBar, Toolbar } from '@mui/material';
import { get } from 'global/lib/lodash';
import clsx from 'clsx';
import styles from './styles';
import { useScreen } from '../../styles';
import { Button } from '../Button';

export const FullScreen = (props) => {
  const classes = styles();

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog data-testid="perform-dialog" className={classes.dialog} fullScreen disableEscapeKeyDown open={props.open} onClose={() => handleClose()}>
      <DialogTitle classes={{ root: classes.dialogTitle }}>
        <AppBar color="secondary" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <IconButton edge="start" color="inherit" onClick={() => handleClose()} aria-label="Close" size="large">
              <Icon>{get(props, 'closeIcon', 'close')}</Icon>
            </IconButton>

            {props.renderTitle ? (
              props.renderTitle()
            ) : (
              <div className={classes.barTitle}>
                <Typography variant="h5" className={classes.titleFull}>
                  {typeof props.title === 'function' ? props.title() : props.title}
                </Typography>
              </div>
            )}

            {!!props.endIcon && (
              <Icon onClick={props.endIconClick} style={{ marginLeft: 'auto', cursor: props.endIconClick ? 'pointer' : 'defautl' }}>
                {props.endIcon}
              </Icon>
            )}
            {!!props.renderEndIcon && props.renderEndIcon(props)}
          </Toolbar>
        </AppBar>
      </DialogTitle>

      <DialogContent style={props.centerContentStyle} className={clsx(classes.contentWrap, props.centerContent)}>
        {props.children}
      </DialogContent>

      {!!props.buttons && (
        <DialogActions {...(props.dialogActions || {})}>
          {(props.buttons || []).map((btn, i) => {
            return (
              <Button key={i} color="secondary" {...btn}>
                {get(btn, 'title', 'Done')}
              </Button>
            );
          })}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default (props) => {
  const { isMobile } = useScreen();
  const classes = styles();

  const Comp = props.content || props.children;

  return (
    <Dialog
      keepMounted={props.keepMounted}
      classes={{
        paperWidthSm: clsx(isMobile || get(props, 'fullHeight', false) ? classes.paperHeight : undefined, !isMobile ? classes.paperMaxWidth : undefined),
        root: clsx(isMobile ? classes.paperWidthMobile : classes.paperWidth, !isMobile ? classes.paperMaxWidth : undefined),
        ...(props.classes || {}),
      }}
      maxWidth={props.maxWidth || undefined}
      fullWidth={props.fullWidth || undefined}
      fullScreen={isMobile || props.fullScreen}
      className={clsx(isMobile ? classes.containerMobile : classes.container, props.className)}
      open={!!props.open}
      onClose={() => props.onClose()}
    >
      <DialogTitle className={classes.title}>{props.title}</DialogTitle>

      <DialogContent classes={{ root: classes.dialogContent }}>
        {Comp && !props.children && (
          <div style={{ minWidth: isMobile ? '100%' : props.minWidth || 500 }} className={isMobile ? classes.contentMobile : classes.content}>
            {typeof props.content === 'function' ? <Comp /> : props.content}
          </div>
        )}

        {props.children && (
          <div style={{ minWidth: isMobile ? '100%' : props.minWidth || 500 }} className={isMobile ? classes.contentMobile : classes.content}>
            {props.children}
          </div>
        )}
      </DialogContent>

      <IconButton onClick={() => props.onClose()} className={classes.close} size="large">
        <Icon>close</Icon>
      </IconButton>

      <DialogActions {...(props.dialogActions || {})}>
        {(props.buttons || []).map((btn, i) => {
          return (
            <Button key={i} color="secondary" {...btn}>
              {get(btn, 'title', 'Done')}
            </Button>
          );
        })}
      </DialogActions>
    </Dialog>
  );
};
